/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Auth_HelpInputs */

const en_live_caption_auth_help = /** @type {(inputs: Live_Caption_Auth_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For OBS this is the WebSocket password. For Custom URL, enter a full authorization header such as Authorization: Bearer token.`)
};

const fr_live_caption_auth_help = /** @type {(inputs: Live_Caption_Auth_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour OBS, il s'agit du mot de passe WebSocket. Pour une URL personnalisée, saisissez un en-tête d'autorisation complet, par exemple : Authorization : Bearer token.`)
};

const de_live_caption_auth_help = /** @type {(inputs: Live_Caption_Auth_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für OBS ist dies das WebSocket-Passwort. Geben Sie für eine benutzerdefinierte URL einen vollständigen Autorisierungsheader ein, z. B. „Authorization: Bearer token“.`)
};

const it_live_caption_auth_help = /** @type {(inputs: Live_Caption_Auth_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per OBS, questa è la password WebSocket. Per URL personalizzato, inserisci un'intestazione di autorizzazione completa come Authorization: Bearer token.`)
};

const ru_live_caption_auth_help = /** @type {(inputs: Live_Caption_Auth_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для OBS это пароль WebSocket. Для пользовательского URL-адреса введите полный заголовок авторизации, например, Authorization: Bearer token.`)
};

const es_live_caption_auth_help = /** @type {(inputs: Live_Caption_Auth_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para OBS, esta es la contraseña de WebSocket. Para una URL personalizada, ingrese un encabezado de autorización completo como Authorization: Bearer token.`)
};

const zh_cn2_live_caption_auth_help = /** @type {(inputs: Live_Caption_Auth_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对于 OBS，这是 WebSocket 密码。对于自定义 URL，请输入完整的授权标头，例如 Authorization: Bearer token。`)
};

const ja_live_caption_auth_help = /** @type {(inputs: Live_Caption_Auth_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OBSの場合、これはWebSocketのパスワードです。カスタムURLの場合は、Authorization: Bearer tokenなどの完全な認証ヘッダーを入力してください。`)
};

const hi_live_caption_auth_help = /** @type {(inputs: Live_Caption_Auth_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OBS के लिए यह वेबसॉकेट पासवर्ड है। कस्टम URL के लिए, पूरा ऑथराइजेशन हेडर दर्ज करें, जैसे कि Authorization: Bearer token।`)
};

const pt_pt2_live_caption_auth_help = /** @type {(inputs: Live_Caption_Auth_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para OBS, esta é a senha do WebSocket. Para URL personalizada, insira um cabeçalho de autorização completo, como Authorization: Bearer token.`)
};

/**
* | output |
* | --- |
* | "For OBS this is the WebSocket password. For Custom URL, enter a full authorization header such as Authorization: Bearer token." |
*
* @param {Live_Caption_Auth_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_auth_help = /** @type {((inputs?: Live_Caption_Auth_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Auth_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_auth_help(inputs)
	if (locale === "de") return de_live_caption_auth_help(inputs)
	if (locale === "it") return it_live_caption_auth_help(inputs)
	if (locale === "ru") return ru_live_caption_auth_help(inputs)
	if (locale === "es") return es_live_caption_auth_help(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_auth_help(inputs)
	if (locale === "ja") return ja_live_caption_auth_help(inputs)
	if (locale === "hi") return hi_live_caption_auth_help(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_auth_help(inputs)
	return en_live_caption_auth_help(inputs)
});